export default Object.freeze({
    COOKIE_NAME: "ls_consent",
    FULL_CONSENT: "full-consent",
    NECESSARY_CONSENT: "necessary-consent",
});
